<script>
  let toggleSignature = false;
  export let questionnaire;
</script>

<!-- svelte-ignore missing-declaration -->
<div class="cuestionariocardcontainer">
  <div class="cuestionariocard headerid">
    <div class="cuestionarioitem">
      <div class="fieldlabelcuestionarios whitetext">Cuestionario</div>
    </div>
  </div>
  <div class="cuestionariocard">
    <div class="cardline listadocuestionarios">
      <div class="fieldlabelcuestionarios minmargin">Profesor/a</div>
      <div class="bodytextcuestionario inputmedium minmargin">
        {questionnaire._profesorCod_}
      </div>
      <div class="bodytextcuestionario lastitem fullwidthresponsive">
        {questionnaire._profesor_}
      </div>
    </div>
    <!--     <div class="cardline listadocuestionarios">
      <div class="fieldlabelcuestionarios minmargin">Área</div>
      <div class="bodytextcuestionario inputmedium minmargin">Código</div>
      <div class="bodytextcuestionario lastitem fullwidthresponsive">
        Nombre del Área
      </div>
    </div> -->
    <div class="cardline listadocuestionarios">
      <div class="fieldlabelcuestionarios minmargin">Centro</div>
      <div class="bodytextcuestionario inputmedium minmargin">
        {questionnaire.centroCod}
      </div>
      <div class="bodytextcuestionario lastitem fullwidthresponsive">
        {questionnaire.centro}
      </div>
    </div>
    <div class="cardline listadocuestionarios">
      <div class="fieldlabelcuestionarios minmargin">Departamento</div>
      <div class="bodytextcuestionario inputmedium minmargin">
        {questionnaire.departamentoCod}
      </div>
      <div class="bodytextcuestionario lastitem fullwidthresponsive">
        {questionnaire.departamento}
      </div>
    </div>
    <div class="cardline listadocuestionarios">
      <div class="fieldlabelcuestionarios minmargin">Asignatura</div>
      <div class="bodytextcuestionario inputmedium minmargin">
        {questionnaire.asignaturaCod}
      </div>
      <div class="bodytextcuestionario lastitem fullwidthresponsive">
        {questionnaire.asignatura}
      </div>
    </div>
    <div class="cardline listadocuestionarios">
      <div class="fieldlabelcuestionarios minmargin">Plan</div>
      <div class="bodytextcuestionario inputmedium minmargin">
        {questionnaire.planCod}
      </div>
      <div class="bodytextcuestionario lastitem fullwidthresponsive">
        {questionnaire.plan}
      </div>
    </div>
    <div class="cardline listadocuestionarios">
      <div class="fieldlabelcuestionarios minmargin">Grupo de actividad</div>
      <div class="bodytextcuestionario inputmedium minmargin">
        {questionnaire.grupoCod}
      </div>
      <div class="bodytextcuestionario lastitem fullwidthresponsive">
        {questionnaire.grupo}
      </div>
    </div>
  </div>
</div>

<style>
  .cuestionariocardcontainer {
    width: 100%;
  }
</style>
